import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { DatasafraAgentChatComponent } from '../../shared/components/datasafra-agent-chat/datasafra-agent-chat.component';

@Component({
  selector: 'app-datasafra-agent-page',
  imports: [DatasafraAgentChatComponent, MatProgressSpinnerModule],
  templateUrl: './datasafra-agent.html',
  styleUrl: './datasafra-agent.scss',
})
export class DatasafraAgentPage {}
